import { ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { ContextMenuComponent, ContextMenuService } from '@perfectmemory/ngx-contextmenu';
import { MobileSidenavService } from '@radioking/shared/common-services';
import { Subject } from 'rxjs';
import { ScrollableLineDirective } from '../../../../../shared/scrollable-line.directive';

import { Program } from '../../models/programs.model';
import { MobDeleteProgramComponent } from '../sides/mob-delete-program/mob-delete-program.component';

@Component({
  selector: 'rk-program-line',
  templateUrl: './program-line.component.html',
  styleUrls: ['./program-line.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramLineComponent extends ScrollableLineDirective {
  @Input()
  set isContextMenuOpen(isOpen: boolean) {
    if (this.hasContextMenuOpen && !isOpen) {
      this.hasContextMenuOpen = false;
    }
  }

  @Input() program: Program;
  @Input() contextMenu: ContextMenuComponent;

  hasContextMenuOpen = false;

  @Input()
  resetScrollAxis: Subject<any>;

  constructor(
    protected readonly host: ElementRef,
    private readonly mobileService: MobileSidenavService,
    private readonly contextMenuService: ContextMenuService,
  ) {
    super(host);
    this.iconSize = 65;
  }

  onContextMenu($event: MouseEvent, item: any): void {
    this.hasContextMenuOpen = true;
    this.contextMenuService.show.next({
      item,
      contextMenu: this.contextMenu,
      event: $event,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }

  deleteProgram(e: Event, program: Program) {
    this.mobileService.open(MobDeleteProgramComponent, {
      data: {
        program: program,
      },
    });
  }
}
